import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface IOrganisationFields {
		id?: any;
		selected?: any;
		parentId?: any;
		typeId?: any;
		name?: any;
		description?: any;
		defaultUserId?: any;
		defaultRoleId?: any;
		changedBy?: any;
		datestamp?: any;
		status?: any;
}

export class OrganisationFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public selected: IEntityModelField = { name: "selected", displayName: "Selected", fieldType: FieldType.Byte };
	public parentId: IEntityModelField = { name: "parentId", displayName: "Parent Organisation", fieldType: FieldType.String, pattern: "NameGeneric" };
	public typeId: IEntityModelField = { name: "typeId", displayName: "Type Id", fieldType: FieldType.Int, pattern: "NameGeneric", required: true };
	public name: IEntityModelField = { name: "name", displayName: "Name", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public description: IEntityModelField = { name: "description", displayName: "Description", fieldType: FieldType.String, pattern: "NameGeneric" };
	public defaultUserId: IEntityModelField = { name: "defaultUserId", displayName: "Default User Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public defaultRoleId: IEntityModelField = { name: "defaultRoleId", displayName: "Default Role Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public changedBy: IEntityModelField = { name: "changedBy", displayName: "Changed By", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric", required: true };
	public status: IEntityModelField = { name: "status", displayName: "Status", fieldType: FieldType.Int, pattern: "NameGeneric", required: true };

	constructor() {
		super();
		this.push(this.id);
		this.push(this.selected);
		this.push(this.parentId);
		this.push(this.typeId);
		this.push(this.name);
		this.push(this.description);
		this.push(this.defaultUserId);
		this.push(this.defaultRoleId);
		this.push(this.changedBy);
		this.push(this.datestamp);
		this.push(this.status);
	}
}

export class OrganisationDTO implements IEntityModel {
	protected organisationName: string = "OrganisationModel";
	protected organisationKeyField: string = "id";
	protected organisationDisplayName: string = "Organisation|Organisations";
	protected organisationFields = new OrganisationFields();
	public get name(): string { return this.organisationName };
	public get keyField(): string { return this.organisationKeyField };
	public get displayName(): string { return this.organisationDisplayName };
	public get fields(): OrganisationFields { return this.organisationFields };

	constructor() {};
}
